<div class="analytics-wrapper">

    <!-- <div class="stats-grid">

        <div class="metric-card">
            <div class="gradient-border green-gradient"></div>
            <div class="gradient-bg green-gradient"></div>
            
            <div class="card-header">
                <div class="icon-wrapper green-icon-bg">

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M11.5 3a9.5 9.5 0 0 1 9.5 9.5a9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2 12.5A9.5 9.5 0 0 1 11.5 3m0 1A8.5 8.5 0 0 0 3 12.5a8.5 8.5 0 0 0 8.5 8.5a8.5 8.5 0 0 0 8.5-8.5A8.5 8.5 0 0 0 11.5 4M11 7h1v5.42l4.7 2.71l-.5.87l-5.2-3z"/>
                    </svg>
                </div>
                <div class="badge up">
                    <svg class="arrow-up" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <line x1="12" y1="19" x2="12" y2="5"></line>
                        <polyline points="5,12 12,5 19,12"></polyline>
                    </svg>
                    +10%
                </div>
            </div>
            <div class="card-content">
                <div class="card-value">
                200
                </div>
                <h3 class="card-title">Last 1 Hour</h3>
            </div>
            <div class="decorative-circle emerald-gradient"></div>
        </div>

        <div class="metric-card">
            <div class="gradient-border emerald-gradient"></div>
            <div class="gradient-bg emerald-gradient"></div>
            
            <div class="card-header">
                <div class="icon-wrapper emerald-icon-bg">
                    <img class="image-icon" src="vehicle-images/car2.jpeg" alt="">
                </div>
                <div class="badge up">
                    <svg class="arrow-up" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <line x1="12" y1="19" x2="12" y2="5"></line>
                        <polyline points="5,12 12,5 19,12"></polyline>
                    </svg>
                    +2%
                </div>
            </div>
            <div class="card-value">
              1,000
            </div>
            <h3 class="card-title">Last 24 Hours</h3>
            
            <div class="decorative-circle emerald-gradient"></div>
        </div>
        <div class="metric-card">
            <div class="gradient-border orange-gradient"></div>
            <div class="gradient-bg orange-gradient"></div>
            
            <div class="card-header">
                <div class="icon-wrapper orange-icon-bg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M11.5 3a9.5 9.5 0 0 1 9.5 9.5a9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2 12.5A9.5 9.5 0 0 1 11.5 3m0 1A8.5 8.5 0 0 0 3 12.5a8.5 8.5 0 0 0 8.5 8.5a8.5 8.5 0 0 0 8.5-8.5A8.5 8.5 0 0 0 11.5 4M11 7h1v5.42l4.7 2.71l-.5.87l-5.2-3z"/>
                    </svg>
                </div>
                <div class="badge up">
                    <svg class="arrow-up" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <line x1="12" y1="19" x2="12" y2="5"></line>
                        <polyline points="5,12 12,5 19,12"></polyline>
                    </svg>
                    +12%
                </div>
            </div>
            <div class="card-value">
              15,000
            </div>
            <h3 class="card-title">Last Week</h3>
            <div class="decorative-circle orange-gradient"></div>
        </div>
        <div class="metric-card">
            <div class="gradient-border blue-gradient"></div>
            <div class="gradient-bg blue-gradient"></div>
            
            <div class="card-header">
                <div class="icon-wrapper blue-icon-bg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M11.5 3a9.5 9.5 0 0 1 9.5 9.5a9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 2 12.5A9.5 9.5 0 0 1 11.5 3m0 1A8.5 8.5 0 0 0 3 12.5a8.5 8.5 0 0 0 8.5 8.5a8.5 8.5 0 0 0 8.5-8.5A8.5 8.5 0 0 0 11.5 4M11 7h1v5.42l4.7 2.71l-.5.87l-5.2-3z"/>
                    </svg>
                </div>
                <div class="badge down">
                    <svg class="arrow-down" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <polyline points="19,12 12,19 5,12"></polyline>
                    </svg>
                    -5%
                </div>
            </div>

            <div class="card-value">
              78,000
            </div>
            <h3 class="card-title">Last Month</h3>
            
            <div class="decorative-circle blue-gradient"></div>
        </div>
    </div> -->
    <!-- <div class="stats-grid">
        <div class="metric-card" *ngFor="let item of stats" [ngClass]="{'negative': item.change < 0}">
            <div class="card-header">
                <h3>{{ item.title }}</h3>
                <span class="icon-dots">⋯</span>
            </div>

            <div class="card-body">
                <h1>{{ item.value }}</h1>

                <div class="percentage" [ngClass]="{ 'positive': item.change > 0, 'negative': item.change < 0 }">
                    <span class="arrow">{{ item.change > 0 ? '↑' : '↓' }}</span>
                    {{ item.change | number: '1.2-2' }}%
                </div>


            </div>
            <div class="percentage">
                <p [ngClass]="{ 'positive-text': item.diff > 0, 'negative-text': item.diff < 0 }">
                    {{ item.diff > 0 ? '+' : '' }}{{ item.diff }} <small>Vs Last Month</small>
                </p>
            </div>

            <div class="bottom-bar" [ngClass]="{ 'positive-bar': item.change > 0, 'negative-bar': item.change < 0 }">
            </div>
        </div>
    </div> -->
    <!-- <div class="stats-grid">
        <div class="metric-card">
            <div class="card-header">
                <p class="title">Productive Time <span class="subtitle">/ Day</span></p>
            </div>

            <div class="card-body">
                <div class="time-section">
                <h1 class="hours">12.4 <span class="unit">hr</span></h1>
                <p class="change"><i class="fa fa-arrow-up"></i> +23% <span class="text">last week</span></p>
                </div>

                <div class="chart-section">
                <canvas id="productiveChart"></canvas>
                </div>
            </div>
        </div>
        <div class="metric-card">
            <div class="card-header">
                <p class="title">Productive Time <span class="subtitle">/ Day</span></p>
            </div>

            <div class="card-body">
                <div class="time-section">
                <h1 class="hours">12.4 <span class="unit">hr</span></h1>
                <p class="change"><i class="fa fa-arrow-up"></i> +23% <span class="text">last week</span></p>
                </div>

                <div class="chart-section">
                <canvas id="productiveChart"></canvas>
                </div>
            </div>
        </div>
        <div class="metric-card">
            <div class="card-header">
                <p class="title">Productive Time <span class="subtitle">/ Day</span></p>
            </div>

            <div class="card-body">
                <div class="time-section">
                <h1 class="hours">12.4 <span class="unit">hr</span></h1>
                <p class="change"><i class="fa fa-arrow-up"></i> +23% <span class="text">last week</span></p>
                </div>

                <div class="chart-section">
                <canvas id="productiveChart"></canvas>
                </div>
            </div>
        </div>
        <div class="metric-card">
            <div class="card-header">
                <p class="title">Productive Time <span class="subtitle">/ Day</span></p>
            </div>

            <div class="card-body">
                <div class="time-section">
                <h1 class="hours">12.4 <span class="unit">hr</span></h1>
                <p class="change"><i class="fa fa-arrow-up"></i> +23% <span class="text">last week</span></p>
                </div>

                <div class="chart-section">
                <canvas id="productiveChart"></canvas>
                </div>
            </div>
        </div>
    </div> -->
<div class="stats-grid">
    <div class="metric-card" *ngFor="let stat of stats1; trackBy: trackByStat">
        <div class="card-header">
        <p class="title">
            {{ stat.title }}
        </p>
        </div>

        <div class="card-body">
        <div class="left">
            <h1 class="value">{{ stat.value }} <span class="unit">Vehicles</span></h1>

            <p class="change" [ngClass]="{'increase': stat.change > 0, 'decrease': stat.change < 0}">
            <i class="fa" [ngClass]="{'fa-arrow-up': stat.change > 0, 'fa-arrow-down': stat.change < 0}"></i>
            {{ stat.change > 0 ? '+' : ''}}{{ stat.change }}%
            <span class="text">vs {{ stat.changeLabel }}</span>
            </p>
        </div>

        <div class="right">
            <canvas [id]="stat?.id"></canvas>
        </div>
        </div>
    </div>
</div>


    <!-- Charts -->
    <div class="charts-container">
        <!-- Donut Chart -->
        <div class="chart-card">
            <!-- <div class="chart-header">
            <h4>RTO / Area Mix</h4>
            <p>Vehicle origin distribution</p>
        </div> -->
            <header class="top-header">
                <h3>RTO / Area Mix</h3>
                <p>Vehicle origin distribution · {{ getRtoDirectionLabel(rtoDirectionMode) }}</p>
            </header>
            <div class="filter-buttons">
                <button *ngFor="let range of timeRanges" [class.active]="range.value === selectedRange"
                    (click)="donutChart(range.value)">
                    {{ range.label }}
                </button>
                <button type="button" class="detail-button" (click)="openRtoDetails()">View Details</button>
            </div>
            <canvas baseChart [data]="donutChartData" [options]="donutChartOptions" type="doughnut">
            </canvas>
        </div>

        <!-- Bar Chart — P22-03: only when Parking Capacity is enabled -->
        <div class="chart-card" *ngIf="showZoneUtilization" data-testid="analytics-zone-utilization">
            <header class="top-header">
                <h3>Zone Utilization</h3>
                <p>Current occupancy by zone</p>
            </header>
            <div class="occupancy-summary">
                <div>
                    <span>Capacity</span>
                    <strong>{{ occupancy.capacity }}</strong>
                </div>
                <div>
                    <span>Occupied</span>
                    <strong>{{ occupancy.occupied }}</strong>
                </div>
                <div>
                    <span>Available</span>
                    <strong>{{ occupancy.available }}</strong>
                </div>
                <div>
                    <span>Utilization</span>
                    <strong>{{ occupancy.occupancy_percent }}%</strong>
                </div>
            </div>
            <canvas baseChart [data]="barChartData" [options]="barChartOptions" type="bar">
            </canvas>
        </div>
    </div>

    <section
        #staleSection
        id="stale-unmatched"
        class="stale-unmatched-panel"
        *ngIf="showOperationalAttention"
        data-testid="analytics-operational-attention">
        <div class="stale-summary-card">
            <div class="stale-summary-copy">
                <span class="stale-attention-badge">Operational Attention</span>
                <h3>Vehicles Pending Exit Verification</h3>
                <p>
                    {{ staleUnmatched.count }} vehicle{{ staleUnmatched.count === 1 ? '' : 's' }} remain in ENTRY
                    beyond {{ staleUnmatched.threshold_hours }} hours. Review manually; records are not auto-resolved.
                </p>
            </div>
            <div class="stale-summary-actions">
                <div class="stale-count-pill">
                    <strong>{{ staleUnmatched.count }}</strong>
                    <span>require review</span>
                </div>
                <button
                    type="button"
                    class="btn-save btn-primary-action"
                    *ngIf="!staleDetailsExpanded"
                    (click)="openStaleDetails()">
                    Review Vehicles
                </button>
                <button
                    type="button"
                    class="btn-cancel"
                    *ngIf="staleDetailsExpanded"
                    (click)="closeStaleDetails()">
                    Hide Details
                </button>
            </div>
        </div>

        <div class="stale-details-panel" *ngIf="staleDetailsExpanded">
            <div class="stale-loading" *ngIf="staleLoading">Loading stale vehicle records...</div>
            <div class="responsive-table-wrapper stale-unmatched-table" *ngIf="!staleLoading">
                <table>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Vehicle Number</th>
                            <th>Entry Time</th>
                            <th>Stale Duration</th>
                            <th>Camera</th>
                            <th>Vehicle Images</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of staleRows; let i = index">
                            <td>{{ i + 1 + (staleCurrentPage - 1) * staleRecordsPerPage }}</td>
                            <td [appVehicleNumberCopy]="row.vehicle_number">{{ row.vehicle_number }}</td>
                            <td>{{ row.entry_time | date: 'medium' }}</td>
                            <td>{{ formatStaleDuration(row.stale_hours) }}</td>
                            <td>{{ row.camera_esn }}</td>
                            <td>
                                <button
                                    type="button"
                                    class="view-image-btn"
                                    [disabled]="!row.entry_vehicle_image_url"
                                    [style.opacity]="row.entry_vehicle_image_url ? 1 : 0.5"
                                    (click)="viewStaleImage(row.entry_vehicle_image_url)">
                                    <fa-icon [icon]="['fas', 'eye']"></fa-icon>
                                </button>
                            </td>
                        </tr>
                        <tr *ngIf="!staleRows.length">
                            <td colspan="6">No stale vehicle records on this page.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <app-vte-pagination
                    *ngIf="staleDetailsExpanded && staleTotalRecords > 0"
                    [currentPage]="staleCurrentPage"
                    [pageSize]="staleRecordsPerPage"
                    [totalRecords]="staleTotalRecords"
                    [showJumpToPage]="true"
                    (pageChange)="onStalePageChange($event)"
                    (pageSizeChange)="onStalePageSizeChange($event)">
            </app-vte-pagination>
        </div>
    </section>

    <app-image-viewer
        [images]="selectedImages"
        [show]="showImageModal"
        [closeModal]="closeImageModal">
    </app-image-viewer>

    <div *ngIf="showRtoDetails" class="confirmation-modal">
        <div class="modal-content rto-detail-modal">
            <div class="modal-header">
                <h3>RTO / Area Details</h3>
                <button type="button" class="modal-close-icon" (click)="closeRtoDetails()" aria-label="Close details"><fa-icon [icon]="['fas', 'xmark']"></fa-icon></button>
            </div>
            <div class="responsive-table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Area</th>
                            <th>Number of Vehicles</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of rtoDetailRows">
                            <td>{{ row.label }}</td>
                            <td>{{ row.count }}</td>
                        </tr>
                        <tr *ngIf="!rtoDetailRows.length">
                            <td colspan="2">No area data available.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="button-row">
                <button class="btn-cancel" type="button" (click)="closeRtoDetails()">Close</button>
            </div>
        </div>
    </div>
</div>
